import { Injectable, Type } from '@angular/core';
import { SupportedTypeMap } from '@nibtravel/shared/util/models';

@Injectable({ providedIn: 'root' })
export class ContentTypeRegistry {
  #items: Map<string, Type<any>> = new Map<string, Type<any>>();

  public register(value: SupportedTypeMap): void {
    for (const key in value) {
      this.#items.set(key, value[key]);
    }
  }

  public get(name: string): Type<any> | undefined {
    return this.#items.get(name);
  }
}
